import {useState, useEffect, useMemo} from 'react';
import Select from 'react-select';
import { useTheme } from '@mui/material';

const SelectRangoFechaTicket = ({
    id,
    value,
    onChange,
    isInvalid,
    isClearable,
    disabled,
    defaultProps,
    filtro
}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [selectedValue, setSelectedValue] = useState(value);
    const [options, setOptions] = useState([]);
    const [items, setItems] = useState([
        {
            label: 'Fecha de Creacion',
            value: 'createdAt',
            tipo: 'fechahora'
        },
        {
            label: 'Fecha de Vencimiento',
            value: 'fechavencimiento_tk',
            tipo: 'fecha'
        },
        {
            label: 'Fecha de Cierre',
            value: 'cerrado_tk',
            tipo: 'fechahora'
        },
        {
            label: 'Fecha de Reapertura',
            value: 'reopeningDate_tk',
            tipo: 'fechahora'
        },
    ]);

    useEffect(() => {
        if(Array.isArray(filtro) && filtro?.length > 0){
            const arrayNuevo = []
            items.forEach((item) => {
                if(!filtro.includes(item?.value)){
                    arrayNuevo.push(item);
                }
            });
            setOptions(arrayNuevo);
        }else{
            setOptions(items);
        }
    }, [filtro])

    const onSelectValue = (ev) => {
        setSelectedValue(ev);
        onChange(ev);
    };

    useEffect(() => {
        if (typeof value === 'string') {
            setSelectedValue(options.find((opt) => opt.value === value));
        }
    }, [value,options]);
    const customStyles = useMemo(() => ({
        menuPortal: (base) => ({...base, zIndex: 9999}),
        menu: (provided) => ({
            ...provided,
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? (isDarkMode ? '#90caf9' : '#fff') : (isDarkMode ? '#e0e0e0' : '#000'),
            background: state.isSelected ? (isDarkMode ? '#1a3a5c' : '#0364ff') : (isDarkMode ? '#2d3a52' : '#fff'),
            '&:hover': {
                backgroundColor: isDarkMode ? '#3d4a62' : '#02378c',
                color: isDarkMode ? '#e0e0e0' : '#e0e0e0',
            },
        }),
        control: (styles) => ({
            ...styles,
            borderRadius: 7,
            borderColor: isDarkMode ? '#3d4a62' : 'gray',
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
        }),
        singleValue: (provided) => ({
            ...provided,
            color: isDarkMode ? '#e0e0e0' : '#000',
        }),
        input: (provided) => ({
            ...provided,
            color: isDarkMode ? '#e0e0e0' : '#000',
        }),
        placeholder: (provided) => ({
            ...provided,
            color: isDarkMode ? '#b0bec5' : 'gray',
        }),
        multiValue: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: isDarkMode ? '#1a3a5c' : '#0364ff',
                borderRadius: 5
            };
        },
        multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5,
            '&:hover': {
                backgroundColor: isDarkMode ? '#3d4a62' : '#02378c',
                color: '#fff',
            },
        }),
    }), [isDarkMode])
    return (
        <Select
            {...defaultProps}
            inputId={id}
            className={`react-select-container ${
                isInvalid ? 'is-invalid' : ''
            }`}
            styles={customStyles}
            menuPortalTarget={document.body}
            classNamePrefix="react-select"
            placeholder="Seleccione..."
            options={options}
            value={selectedValue}
            onChange={onSelectValue}
            isClearable={isClearable}
            isDisabled={disabled}
            menuShouldScrollIntoView
            menuPosition='absolute'
            menuPlacement='auto'
        />
    );
};

SelectRangoFechaTicket.defaultProps = {
    isClearable: false,
    value: null
};

export default SelectRangoFechaTicket;